import { render, staticRenderFns } from "./TheVdApplication.vue?vue&type=template&id=9852cfea&"
import script from "./TheVdApplication.vue?vue&type=script&lang=js&"
export * from "./TheVdApplication.vue?vue&type=script&lang=js&"
import style0 from "./TheVdApplication.vue?vue&type=style&index=0&id=9852cfea&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports